import React from 'react';
import { cn } from '@/lib/utils';

interface IPageHeaderProps {
	title?: string;
	description?: string;
	children?: any;
	className?: string;
	action?: React.ReactNode;
}

export const PageHeader = ({ children, title, description, action, className }: IPageHeaderProps) => {
	return (
		<div className={cn(
			"mb-4 space-y-3 relative isolate",
			className
		)}>
			<div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
				{(title || description) && (
					<div className="space-y-1">
						{title && (
							<h1 className="text-xl font-bold tracking-tight text-foreground/95 md:text-2xl">
								{title}
							</h1>
						)}
						{description && (
							<p className="max-w-3xl text-sm text-muted-foreground/90">
								{description}
							</p>
						)}
					</div>
				)}
					{action && (
					<div className="flex flex-wrap items-center gap-2 [&_ul]:m-0 [&_ul]:list-none [&_ul]:pl-0 [&_li]:m-0 [&_li]:list-none">
							{action}
						</div>
					)}
				</div>
				{children && (
				<div className="mt-3 border-t border-border/60 pt-3 [&_ul]:m-0 [&_ul]:list-none [&_ul]:pl-0 [&_li]:m-0 [&_li]:list-none">
						{children}
					</div>
				)}
		</div>
	);
};
